"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LibrariesInitializer = exports.LibrariesInitializationError = void 0;
const web_ui_framework_1 = require("@gruposantander/web-ui-framework");
const _1 = require(".");
const LIBRARIES_ERROR = 'Libraries initialization error';
class LibrariesInitializationError extends web_ui_framework_1.InitializerError {
    constructor(message) {
        super(LIBRARIES_ERROR, message);
    }
}
exports.LibrariesInitializationError = LibrariesInitializationError;
class LibrariesInitializer extends web_ui_framework_1.Initializer {
    constructor(config) {
        super();
        this.launch = async () => {
            try {
                await (0, _1.initLibraries)(this.config);
            }
            catch (e) {
                throw new LibrariesInitializationError(e);
            }
        };
        this.config = config;
    }
}
exports.LibrariesInitializer = LibrariesInitializer;
//# sourceMappingURL=libraries.initializer.js.map